import { LitElement, html, css } from 'lit';

export class CrusherIconLink extends LitElement {
  static properties = {
    href: { type: String, reflect: true },
    label: { type: String, reflect: true },
    target: { type: String },
    rel: { type: String },
    disabled: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.href = '';
    this.label = '';
    this.target = '';
    this.rel = '';
    this.disabled = false;
  }

  static styles = css`
    :host {
      display: inline-flex;
      inline-size: var(--crusher-icon-link-size, var(--crusher-spacing-10));
      block-size: var(--crusher-icon-link-size, var(--crusher-spacing-10));
      color: var(--crusher-icon-link-color, var(--crusher-fg-muted));
      background: var(--crusher-icon-link-bg, transparent);
      border: var(--crusher-icon-link-border-width, 0) solid var(--crusher-icon-link-border, transparent);
      border-radius: var(--crusher-icon-link-radius, var(--crusher-radius-full));
      transition:
        color var(--crusher-transition-duration-base, var(--crusher-motion-duration-base)) var(--crusher-transition-easing-inout, var(--crusher-motion-easing-inout)),
        background-color var(--crusher-transition-duration-base, var(--crusher-motion-duration-base)) var(--crusher-transition-easing-inout, var(--crusher-motion-easing-inout)),
        transform var(--crusher-transition-duration-base, var(--crusher-motion-duration-base)) var(--crusher-transition-easing-inout, var(--crusher-motion-easing-inout));
    }

    :host(:hover) {
      color: var(--crusher-icon-link-hover-color, var(--crusher-color-brand-primary));
      background: var(--crusher-icon-link-hover-bg, var(--crusher-icon-link-bg, transparent));
      transform: var(--crusher-icon-link-hover-transform, none);
    }

    :host([disabled]) {
      opacity: var(--crusher-opacity-disabled);
      pointer-events: none;
    }

    a {
      inline-size: 100%;
      block-size: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: inherit;
      text-decoration: none;
      border-radius: inherit;
      font-size: var(--crusher-icon-link-font-size, 1em);
    }

    ::slotted(*) {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  `;

  _onClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  render() {
    const rel = this.rel || (this.target === '_blank' ? 'noopener noreferrer' : '');

    return html`
      <a
        href=${this.disabled ? '' : this.href}
        target=${this.target || ''}
        rel=${rel}
        aria-label=${this.label || ''}
        aria-disabled=${this.disabled ? 'true' : 'false'}
        tabindex=${this.disabled ? '-1' : '0'}
        @click=${this._onClick}
      >
        <slot></slot>
      </a>
    `;
  }
}

customElements.define('crusher-icon-link', CrusherIconLink);
